<script lang="ts" setup>
import BaseIcon from '@/components/ui/BaseIcon/BaseIcon.vue'
import { useToast } from '@/composables/useToast'
import {
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastRoot,
  ToastViewport,
} from 'reka-ui'

const { toast, isOpened } = useToast()
</script>
<template>
  <ToastProvider>
    <ToastRoot
      class="toast"
      :class="{ '!bg-white !text-black': toast.variant === 'WHITE' }"
      :duration="toast.actionButton ? 7000 : 3000"
      v-model:open="isOpened"
    >
      <div class="flex gap-2.5">
        <BaseIcon
          v-if="toast.icon"
          class="shrink-0"
          :class="{
            'text-turquoise-5': toast.iconColor === 'primary',
            'text-red-5': toast.iconColor === 'error',
          }"
          :icon="toast.icon"
        />
        <ToastDescription
          v-if="!toast.messageComponent"
          class="flex flex-col items-start text-start"
        >
          <div class="text-base" :class="{ 'font-semibold': toast.description }">
            {{ toast.message }}
          </div>
          <div class="text-start empty:hidden">{{ toast.description }}</div>
        </ToastDescription>
        <ToastDescription v-else as-child class="flex flex-col">
          <component :is="toast.messageComponent" />
        </ToastDescription>
      </div>
      <ToastAction v-if="toast.actionButton" as-child :alt-text="toast.actionButton.title">
        <button
          class="font-semibold text-primary transition-colors hover:text-primary-hover active:text-primary-active"
          @click="toast.actionButton.action()"
        >
          {{ toast.actionButton.title }}
        </button>
      </ToastAction>
      <ToastClose
        class="text-white transition-colors hover:text-primary active:text-primary-active"
      >
        <BaseIcon class="w-3.8" icon="CloseIcon" />
      </ToastClose>
    </ToastRoot>
    <ToastViewport
      class="fixed bottom-10 right-10 z-[2147483647] m-0 flex max-w-[100vw] list-none flex-col items-end gap-[10px] outline-none"
      :class="{ 'w-[480px]': toast.restrictedWidth }"
    />
  </ToastProvider>
</template>

<style lang="postcss">
.toast {
  @apply flex items-center gap-5 rounded-card bg-secondary px-5 py-[18px] text-right text-base text-white shadow;
  @apply data-[state=closed]:animate-hideOut data-[state=open]:animate-slideIn;
}

.toast[data-swipe='move'] {
  transform: translateX(var(--reka-toast-swipe-move-x));
}
.toast[data-swipe='cancel'] {
  transform: translateX(0);
  transition: transform 200ms ease-out;
}
.toast[data-swipe='end'] {
  animation: slideRight 100ms ease-out;
}

@keyframes slideRight {
  from {
    transform: translateX(var(--reka-toast-swipe-end-x));
  }
  to {
    transform: translateX(calc(100% + 40px));
    opacity: 0;
  }
}
</style>
